/* src/app/components/modal-cierre-sesion/modal-cierre-sesion.component.scss */
.confirmar {
  padding: 24px;
  text-align: center;
}
.confirmar__title {
  margin: 0;
  font-weight: 700;
  font-size: 28px;
  margin-bottom: 24px;
  color: black;
}
.confirmar__description {
  margin: 0;
  font-size: 20px;
  font-weight: 400;
  margin-bottom: 24px;
  color: #434343;
}
.confirmar__buttons .eliminar {
  margin-bottom: 24px;
  --background: #373737;
  color: white;
  --border-radius: 10px;
  font-size: 24px;
  font-weight: 700;
  height: 64px;
}
.confirmar__buttons .cancelar {
  --background: #f2f2f2;
  color: #373737;
  --border-radius: 10px;
  font-size: 24px;
  font-weight: 700;
  height: 64px;
}
/*# sourceMappingURL=modal-cierre-sesion.component.css.map */
